import React, { createContext, useMemo } from "react";

import { graphql } from "relay-runtime";

import ActionItemsPage from "~/actionItems";

import styles from "./ActionItemsTab.module.css";

type ActionItemsTabContextType = {
	streamId: string;
};

export const ActionItemsTabContext = createContext<ActionItemsTabContextType>({
	streamId: "",
});

interface ActionItemsTabProps {
	streamId: string;
}

export const ToggleCheckedMutation = graphql`
	mutation ActionItemsTabToggleCheckedMutation($input: ToggleBlockFieldInput!) {
		toggleBlockField(input: $input) {
			ok
			noteBlockEdge {
				node {
					id
					done
					wontDo
					note {
						stream {
							openActionItemCount
						}
					}
					originalBlock {
						id
						done
						wontDo
						childBlocks {
							edges {
								node {
									id
									done
									wontDo
								}
							}
						}
					}
					childBlocks {
						edges {
							node {
								id
								done
								wontDo
							}
						}
					}
				}
			}
		}
	}
`;

export default function ActionItemsTab({ streamId }: ActionItemsTabProps) {
	const contextValues = useMemo<ActionItemsTabContextType>(() => {
		return {
			streamId,
		};
	}, [streamId]);

	return (
		<div className={styles.actionItemsTab}>
			<ActionItemsTabContext.Provider value={contextValues}>
				<ActionItemsPage />
			</ActionItemsTabContext.Provider>
		</div>
	);
}
